import type { BoardModelKind } from "../kind";
import {
  ensureBoardModelDebugLabelHost,
} from "../labelHost";

const LOCATION_MODEL: BoardModelKind = "Location";

export function updateLocationCohortLabel(
  world: HTMLElement,
  debugId: string,
  placeLines: readonly string[],
): void {
  const host = ensureBoardModelDebugLabelHost(world);
  const label = host.querySelector<HTMLElement>(
    `[data-board-debug-label][data-board-model="${LOCATION_MODEL}"]`
      + `[data-board-id="${CSS.escape(debugId)}"]`,
  );
  if (label === null) {
    return;
  }
  let kind = label.querySelector<HTMLElement>(".board-model-debug__label-kind");
  let detail = label.querySelector<HTMLElement>(
    ".board-model-debug__label-detail",
  );
  if (kind === null || detail === null) {
    label.replaceChildren();
    kind = document.createElement("span");
    kind.className = "board-model-debug__label-kind";
    kind.textContent = LOCATION_MODEL;
    detail = document.createElement("span");
    detail.className = "board-model-debug__label-detail";
    label.append(kind, detail);
  }
  detail.textContent = placeLines.join("\n");
}

export function appendLocationCohortLabel(
  label: HTMLElement,
  model: BoardModelKind,
): void {
  if (model !== LOCATION_MODEL) {
    label.textContent = model;
    return;
  }
  const kind = document.createElement("span");
  kind.className = "board-model-debug__label-kind";
  kind.textContent = model;
  const detail = document.createElement("span");
  detail.className = "board-model-debug__label-detail";
  label.append(kind, detail);
}
